import { combineReducers, Reducer } from 'redux'
import { History } from 'history';

import dataFinalReducer from './data/dataFinalReducer';
import accessFinalReducer from './accessControl/accessControlFinalReducer';
import mainFinalReducer from './main/mainFinalReducer';
import schemaFinalReducer from './schema/schemaFinalReducer';
import modelDataFinalReducer from './modelData/modelDataFinalReducer';
import trainedModelFinalReducer from './trainedModel/trainedModelFinalReducer';
import subscriptionFinalReducer from './subscription/subscriptionFinalReducer';

import { initialState as dataState } from './data/dataModel';
import { initialState as accessState } from './accessControl/accessControlModel';
import { initialState as subscriptionState } from './subscription/subscriptionModel';

import { initialState as mainState } from './main/mainModel';
import { initialState as schemaState } from './schema/schema';
import { initialState as modelDataState } from './modelData/modelData';
import { initialState as trainedModelState } from './trainedModel/trainedModel';

/*
 * initialState of the app
 */
export const initialState = {
    data: dataState,
    access: accessState,
    subscription: subscriptionState,
    main: mainState,
    schemaState: schemaState,
    modelDataState: modelDataState,
    trainedModelState: trainedModelState,
};

/*
 * This is the root state of the app
 * It contains every substate of the app
 */
export type RootStoreType = typeof initialState

/*
 * Root reducer of the app
 * Returned reducer will be of type Reducer<State>
 */

export const createRootReducer = (history: History): Reducer<RootStoreType> => combineReducers({
    data: dataFinalReducer,
    access: accessFinalReducer,
    main: mainFinalReducer,
    schemaState: schemaFinalReducer,
    modelDataState: modelDataFinalReducer,
    trainedModelState: trainedModelFinalReducer,
    subscription: subscriptionFinalReducer,

})